export default "__VITE_ASSET__CEqN3oL9__"